import { Chip, InputAdornment, TextField } from "@mui/material";
import type { DisplayOnlyTextFieldProps } from "../../types";

function DisplayOnlyTextField({
  id,
  label,
  value,
  error = false,
  helperText,
  badge,
}: DisplayOnlyTextFieldProps) {
  return (
    <TextField
      id={id}
      label={label}
      value={value}
      size="small"
      multiline
      error={error}
      helperText={helperText}
      slotProps={{
        input: {
          readOnly: true,
          endAdornment: badge && (
            <InputAdornment position="end">
              <Chip
                label={badge.label}
                size="small"
                sx={{
                  fontWeight: 700,
                  color: "text.primary",
                  backgroundColor: badge.highlighted
                    ? "brand.earthlyLight"
                    : "grey.200",
                }}
              />
            </InputAdornment>
          ),
        },
        htmlInput: {
          tabIndex: -1,
          "aria-readonly": true,
          style: {
            caretColor: "transparent",
            pointerEvents: "none",
            userSelect: "none",
          },
        },
      }}
      sx={{
        paddingBottom: 2,
        overflowWrap: "anywhere",
        whiteSpace: "pre-line",
        pointerEvents: "none",
        userSelect: "none",
        "& input, & textarea": {
          caretColor: "transparent",
          userSelect: "none",
        },
      }}
    />
  );
}

export default DisplayOnlyTextField;
